import React from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import ProductShowcase from "@/components/ProductShowcase";
import EtchDepths from "@/components/EtchDepths";
import PowerInAction from "@/components/PowerInAction";
import System from "@/components/System";
import Resources from "@/components/Resources";
import Montreal from "@/components/Montreal";
import Quote from "@/components/Quote";
import Footer from "@/components/Footer";
import StickyCall from "@/components/StickyCall";

const Landing = () => {
  return (
    <main className="bg-[#faf7f2] text-[#14141a]" data-testid="landing-page">
      <Header />
      <Hero />
      <Marquee />
      <ProductShowcase />
      <EtchDepths />
      <PowerInAction />
      <System />
      <Resources />
      <Montreal />
      <Quote />
      <Footer />
      <StickyCall />
    </main>
  );
};

export default Landing;
